const translations = {
  "en": {
    "Ask": "Ask"
  },
  "zh-tw": {
    "Ask": "提問"
  }
};

export default translations;
